var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultitap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 63,
    viewBox: "0 0 59 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1672 53.4515L30.1465 54.8878C28.9853 55.7135 27.5842 57.466 27.0342 58.7834L26.3689 60.3754C25.7417 59.51 24.4908 58.5167 22.2882 57.594C20.0085 56.6387 17.2738 55.9906 15.3459 55.6104C15.8672 54.152 16.4147 52.5218 16.3787 52.2029L16.1446 50.1013C16.0402 49.1642 16.2085 47.6684 16.5188 46.7776L19.2805 38.8457L19.2805 32.6965L20.0939 29.8711L23.6895 30.4675L24.4709 27.2353L28.0976 27.9884L28.3478 29.6361L28.9571 29.6361L29.3482 23.4378L29.8851 21.6278C30.0713 21.0012 30.7512 20.5652 31.3962 20.6605L31.6294 20.6945C32.1466 20.7709 32.5979 21.2607 32.6336 21.7835L32.8819 25.4149L32.3816 30.7185L32.8508 30.7185L36.8847 19.076L37.9021 17.7444C38.3055 17.2169 39.1489 16.9612 39.7752 17.1754L40.0591 17.2726C40.6863 17.4877 41.0747 18.1927 40.9214 18.8401L32.1672 53.4515Z",
    fill: "white",
    stroke: "#0F0F0F",
    strokeWidth: 0.225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9207 39.5078L20.6545 39.5352",
    stroke: "#9583FF",
    strokeWidth: 0.225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8316 25.9258L57.9868 27.0818C58.0714 27.7084 57.7489 28.3756 57.0655 28.8192L56.9104 27.6631C57.5938 27.2196 57.9163 26.5524 57.8316 25.9258Z",
    fill: "#9583FF",
    stroke: "#0F0F0F",
    strokeWidth: 0.225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2946 35.8804L17.1396 34.7243C17.0766 34.2553 17.3172 33.757 17.8284 33.4258L17.9834 34.5818C17.4732 34.914 17.2317 35.4123 17.2946 35.8804Z",
    fill: "#0F0F0F",
    stroke: "#0F0F0F",
    strokeWidth: 0.225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6357 36.5526C17.4384 36.3544 17.3257 36.1213 17.2937 35.8806L17.1387 34.7246C17.1706 34.9653 17.2834 35.1983 17.4807 35.3965C17.5277 35.7429 17.5897 36.2053 17.6357 36.5526Z",
    fill: "white",
    stroke: "#0F0F0F",
    strokeWidth: 0.225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.371 25.0264C58.1496 25.8078 57.9427 26.9912 56.9075 27.6632L29.6972 45.3407C28.6628 46.0126 27.1875 45.9229 26.409 45.1406L17.0069 35.7045C16.2284 34.9231 16.4352 33.7397 17.4696 33.0678L44.6798 15.3903C45.7142 14.7183 47.1895 14.808 47.969 15.5894L57.371 25.0255L57.371 25.0264Z",
    fill: "#0F0F0F",
    stroke: "#0F0F0F",
    strokeWidth: 0.225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9023 25.3341C57.4843 25.9183 57.3291 26.8025 56.5562 27.3055L29.346 44.983C28.573 45.4851 27.4691 45.4181 26.8871 44.8339L17.4851 35.3978C16.903 34.8137 17.0582 33.9294 17.8311 33.4264L45.0414 15.7489C45.8143 15.2469 46.9182 15.3139 47.5002 15.898L56.9023 25.3341Z",
    fill: "#9583FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4346 20.1358C50.5521 20.2538 50.5211 20.4321 50.3651 20.5341C50.2091 20.636 49.9864 20.6218 49.869 20.5039C49.7515 20.3859 49.7825 20.2075 49.9394 20.1056C50.0954 20.0037 50.3181 20.0169 50.4356 20.1358L50.4346 20.1358Z",
    stroke: "#0F0F0F",
    strokeWidth: 0.225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5025 22.2666C52.6059 22.3704 52.5786 22.5252 52.4413 22.6139C52.304 22.7026 52.1113 22.6913 52.0079 22.5875L50.6435 21.2181C50.5401 21.1143 50.5673 20.9586 50.7037 20.8699C50.84 20.7812 51.0346 20.7935 51.1381 20.8963L52.5025 22.2656L52.5025 22.2666Z",
    stroke: "#0F0F0F",
    strokeWidth: 0.225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7065 35.9588L16.5514 34.8027C16.5947 35.1245 16.745 35.4369 17.01 35.7021L17.165 36.8581C16.901 36.5929 16.7497 36.2806 16.7065 35.9588Z",
    fill: "#0F0F0F",
    stroke: "#0F0F0F",
    strokeWidth: 0.225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4117 45.1412L26.5669 46.2972L17.1639 36.8602L17.0088 35.7051L26.4117 45.1412Z",
    fill: "#9583FF",
    stroke: "#0F0F0F",
    strokeWidth: 0.225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9093 27.6621L57.0645 28.8172L29.8551 46.4947L29.699 45.3396L56.9093 27.6621Z",
    fill: "#9583FF",
    stroke: "#0F0F0F",
    strokeWidth: 0.225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8977 34.1516L49.0754 33.9412L49.0491 33.9148L52.6025 31.6065C52.7238 31.5272 52.814 31.3668 52.8347 31.2129L52.9551 31.0931L52.7567 30.9364C52.6937 30.8874 52.6053 30.8864 52.5141 30.9459L48.8535 33.324C48.7002 33.4231 48.5949 33.6534 48.6194 33.8346C48.6288 33.9072 48.6589 33.9601 48.7002 33.9931L48.7002 33.994L48.8977 34.1507L48.8977 34.1516Z",
    fill: "#0F0F0F",
    stroke: "#0F0F0F",
    strokeWidth: 0.225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7137 31.1005C52.867 31.0014 53.0118 31.0684 53.0363 31.2496C53.0607 31.4308 52.9554 31.6611 52.8021 31.7602L49.1416 34.1383C48.9883 34.2374 48.8435 34.1704 48.819 33.9892C48.7946 33.808 48.8999 33.5777 49.0532 33.4787L52.7137 31.1005Z",
    fill: "#9583FF",
    stroke: "#0F0F0F",
    strokeWidth: 0.225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6986 45.3407L29.8538 46.4967C28.8194 47.1686 27.3441 47.079 26.5655 46.2967L26.4104 45.1406C27.189 45.922 28.6643 46.0117 29.6986 45.3407Z",
    fill: "#9583FF",
    stroke: "#0F0F0F",
    strokeWidth: 0.225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0261 35.2535C34.5893 35.7688 31.46 34.1371 30.9118 31.4674C30.7087 30.4774 30.8874 29.478 31.3641 28.5664",
    stroke: "white",
    strokeWidth: 0.225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5602 24.899C40.7318 24.6688 43.5085 26.258 44.0219 28.7579C44.1884 29.5694 44.0981 30.3876 43.7972 31.1577",
    stroke: "white",
    strokeWidth: 0.225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7212 21.609C41.8087 20.3501 47.5247 23.1369 48.4895 27.8328C48.8694 29.6815 48.4556 31.551 47.4429 33.2147",
    stroke: "white",
    strokeWidth: 0.225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2114 38.6141C33.124 39.873 27.4079 37.0862 26.4432 32.3904C26.0708 30.5784 26.4601 28.7476 27.4286 27.1094",
    stroke: "white",
    strokeWidth: 0.225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4675 27.2323L24.6678 26.5358C24.7994 26.0772 25.2827 25.6015 25.7416 25.4779L26.3773 25.3071C27.0289 25.1316 27.7642 25.5043 28.0096 26.1357L28.807 28.1826C28.9593 28.5742 28.7985 29.0857 28.4497 29.3188L27.9428 29.6576C27.4671 29.9747 26.8418 29.9482 26.3951 29.5906C26.0416 29.3075 25.6532 28.8592 25.3533 28.1533L24.4675 27.2332L24.4675 27.2323Z",
    fill: "white",
    stroke: "#0F0F0F",
    strokeWidth: 0.225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0906 29.8693L20.3059 29.1191C20.4291 28.6906 20.8814 28.2433 21.3101 28.1254L21.8743 27.9706C22.588 27.7743 23.2622 28.2141 23.3741 28.9483L23.6627 30.8489C23.7248 31.2556 23.4549 31.6907 23.0638 31.8153L22.3886 32.0295C21.9006 32.1843 21.3355 31.9257 21.1324 31.4548L20.7403 30.545L20.0896 29.8693L20.0906 29.8693Z",
    fill: "white",
    stroke: "#0F0F0F",
    strokeWidth: 0.225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M25.059 45.5331L29.9682 43.3382C30.7092 43.0135 31.9711 42.653 32.7722 42.5379L36.3566 42.0208L39.9297 38.462C40.3312 38.0619 41.0581 37.5004 41.5461 37.2135L43.4511 36.0924C44.0097 35.764 44.9725 35.6536 45.5903 35.848C46.1235 36.0159 46.4977 36.6077 46.4206 37.1626L46.3736 37.5061C46.3181 37.9043 45.9871 38.3894 45.6373 38.5847L44.5259 39.2066L43.8442 41.3054C43.6881 41.7867 43.3054 42.5049 42.9932 42.9022L39.2659 47.6509C38.5287 48.5908 37.1295 49.9243 36.1563 50.616L32.1648 53.4528",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M25.059 45.5331L29.9682 43.3382C30.7092 43.0135 31.9711 42.653 32.7722 42.5379L36.3566 42.0208L39.9297 38.462C40.3312 38.0619 41.0581 37.5004 41.5461 37.2135L43.4511 36.0924C44.0097 35.764 44.9725 35.6536 45.5903 35.848C46.1235 36.0159 46.4977 36.6077 46.4206 37.1626L46.3736 37.5061C46.3181 37.9043 45.9871 38.3894 45.6373 38.5847L44.5259 39.2066L43.8442 41.3054C43.6881 41.7867 43.3054 42.5049 42.9932 42.9022L39.2659 47.6509C38.5287 48.5908 37.1295 49.9243 36.1563 50.616L32.1648 53.4528",
    stroke: "#0F0F0F",
    strokeWidth: 0.225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0578 45.5332L26.7202 44.8047",
    stroke: "#9583FF",
    strokeWidth: 0.225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6938 41.9883C37.2691 42.0402 37.5916 42.3658 37.5916 42.3658",
    stroke: "#9583FF",
    strokeWidth: 0.225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9907 36.3203L44.7401 37.3008C44.5126 37.4792 44.4148 37.7793 44.4938 38.0586C44.5756 38.3474 44.6348 38.7551 44.5286 39.2062",
    stroke: "#9583FF",
    strokeWidth: 0.225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4031 41.2461L43.2464 42.1775",
    stroke: "#9583FF",
    strokeWidth: 0.225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1209 38.6289L40.6001 38.7969",
    stroke: "#9583FF",
    strokeWidth: 0.225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8383 62.1252C27.1468 61.1711 26.282 59.266 22.2882 57.593C19.1024 56.258 15.028 55.523 13.5086 55.2804C13.1601 55.2246 12.826 55.4356 12.7221 55.7761L10.8502 62.1252",
    stroke: "white",
    strokeWidth: 0.225,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9343 58.1339C14.0408 58.61 14.5678 58.8966 15.1114 58.774C15.6549 58.6515 16.0092 58.1662 15.9026 57.6901C15.7961 57.2141 15.2691 56.9275 14.7255 57.05C14.182 57.1725 13.8277 57.6578 13.9343 58.1339Z",
    fill: "#9583FF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8537 57.97C13.9602 58.4461 14.4872 58.7327 15.0307 58.6101C15.5742 58.4875 15.9285 58.0022 15.822 57.5261C15.7155 57.05 15.1885 56.7634 14.645 56.886C14.1014 57.0086 13.7472 57.4939 13.8537 57.97Z",
    fill: "#F6F3EF",
    stroke: "#0F0F0F",
    strokeWidth: 0.225,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M40.695 29.2149L40.7044 29.9458C40.7156 30.7921 39.9203 31.6038 38.5973 31.9581C36.8556 32.4246 34.8583 31.9217 34.1364 30.8353C33.9628 30.5737 33.8785 30.3028 33.8752 30.0349L33.8658 29.304C33.8691 29.5718 33.9534 29.8428 34.127 30.1044C34.8489 31.1908 36.8462 31.6937 38.5879 31.2272C39.9116 30.8727 40.7062 30.0612 40.695 29.2149Z",
    fill: "#9583FF",
    stroke: "#1E1D1D",
    strokeWidth: 0.225,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9746 27.2908C37.7171 26.8241 39.7137 27.3273 40.4357 28.4143C41.1576 29.5007 40.3315 30.7599 38.5897 31.2264C36.8479 31.6929 34.8506 31.1899 34.1287 30.1036C33.4067 29.0165 34.2328 27.7573 35.9746 27.2908Z",
    fill: "white",
    stroke: "#1E1D1D",
    strokeWidth: 0.225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2492 30.9961C34.7678 30.7769 34.3734 30.4747 34.127 30.1044C33.9534 29.8428 33.8691 29.5718 33.8658 29.304L33.8752 30.0349C33.8785 30.3028 33.9628 30.5737 34.1364 30.8353C34.3685 31.1847 34.7338 31.4736 35.1786 31.6895L35.2485 30.9963L35.2492 30.9961Z",
    fill: "#1E1D1D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1585 25.3333C37.779 24.3982 39.2964 24.3231 39.5474 25.1671C39.7982 26.0103 38.6873 27.4521 37.0668 28.3873C35.4456 29.3226 33.9282 29.3976 33.6774 28.5543C33.4265 27.7111 34.5373 26.2686 36.1585 25.3333Z",
    fill: "white",
    stroke: "#1E1D1D",
    strokeWidth: 0.225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4548 24.9718L39.9181 25.67C39.957 25.7281 39.9868 25.7929 40.0081 25.8644C40.2589 26.7077 39.148 28.1495 37.5275 29.0846C36.0432 29.941 34.6462 30.0763 34.2287 29.4459L33.7654 28.7477C34.1835 29.3779 35.5806 29.2426 37.0641 28.3864C38.6847 27.4513 39.7954 26.0088 39.5448 25.1662C39.5234 25.0947 39.493 25.0301 39.4548 24.9718Z",
    fill: "#9583FF",
    stroke: "#1E1D1D",
    strokeWidth: 0.225,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1585 25.3333C37.779 24.3982 39.2964 24.3231 39.5474 25.1671C39.7982 26.0103 38.6873 27.4521 37.0668 28.3873C35.4456 29.3226 33.9282 29.3976 33.6774 28.5543C33.4265 27.7111 34.5373 26.2686 36.1585 25.3333Z",
    stroke: "#1E1D1D",
    strokeWidth: 0.225,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0134 29.1251C34.4279 29.1864 33.9756 29.0621 33.7668 28.748L34.2302 29.4463C34.4332 29.7524 34.8674 29.8772 35.4305 29.8276L35.0134 29.1251Z",
    fill: "#1E1D1D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9468 21.8117L39.1277 22.6307C39.2846 23.3411 38.2879 24.222 36.7011 24.7068C34.9196 25.2509 33.069 25.0911 32.5672 24.35C32.5127 24.2691 32.4763 24.1849 32.4574 24.0982L32.2765 23.2792C32.2954 23.3659 32.3318 23.4501 32.3863 23.531C32.888 24.272 34.738 24.4321 36.5202 23.8878C38.107 23.403 39.1037 22.5221 38.9468 21.8117Z",
    fill: "#9583FF",
    stroke: "#1E1D1D",
    strokeWidth: 0.225,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7032 21.2018C36.484 20.6579 38.3347 20.8177 38.8358 21.559C39.3376 22.3001 38.3003 23.3426 36.5196 23.8866C34.7381 24.4307 32.8875 24.2709 32.3857 23.5298C31.8839 22.7887 32.9211 21.7461 34.7032 21.2018Z",
    fill: "white",
    stroke: "#1E1D1D",
    strokeWidth: 0.225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7031 21.202C32.9216 21.7461 31.8844 22.7887 32.3855 23.53C32.5632 23.7934 32.912 23.9826 33.3658 24.0934L37.804 20.9833C36.9813 20.7957 35.8277 20.8578 34.7024 21.2022L34.7031 21.202Z",
    fill: "#1E1D1D"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7032 21.2018C36.484 20.6579 38.3347 20.8177 38.8358 21.559C39.3376 22.3001 38.3003 23.3426 36.5196 23.8866C34.7381 24.4307 32.8875 24.2709 32.3857 23.5298C31.8839 22.7887 32.9211 21.7461 34.7032 21.2018Z",
    stroke: "#1E1D1D",
    strokeWidth: 0.225,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6807 24.1564C33.0742 24.0631 32.6051 23.8516 32.388 23.531C32.3335 23.4501 32.2971 23.3659 32.2782 23.2792L32.4591 24.0982C32.478 24.1849 32.5144 24.2691 32.5689 24.35C32.7767 24.6578 33.2176 24.8645 33.7892 24.9634L33.6814 24.1562L33.6807 24.1564Z",
    fill: "#1E1D1D"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7032 21.2018C36.484 20.6579 38.3347 20.8177 38.8358 21.559C39.3376 22.3001 38.3003 23.3426 36.5196 23.8866C34.7381 24.4307 32.8875 24.2709 32.3857 23.5298C31.8839 22.7887 32.9211 21.7461 34.7032 21.2018Z",
    stroke: "#1E1D1D",
    strokeWidth: 0.225,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4451 18.0582C36.0376 17.282 37.048 17.2292 36.7018 17.941C36.356 18.652 34.7843 19.8589 33.1918 20.635C31.5987 21.4113 30.5883 21.4641 30.934 20.7532C31.2802 20.0413 32.8515 18.8353 34.4446 18.059L34.4453 18.0589L34.4451 18.0582Z",
    fill: "white",
    stroke: "#1E1D1D",
    strokeWidth: 0.225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M36.738 17.5767L37.2103 18.3548C37.2611 18.4381 37.2513 18.5595 37.1739 18.7193C36.8282 19.4303 35.2565 20.6371 33.664 21.4132C32.4287 22.0158 31.5435 22.1822 31.3697 21.8952L30.8973 21.1171C31.0711 21.4041 31.9561 21.237 33.1916 20.6351C34.7841 19.859 36.3554 18.653 36.7016 17.9412C36.7796 17.7812 36.7887 17.66 36.738 17.5767Z",
    fill: "#9583FF",
    stroke: "#1E1D1D",
    strokeWidth: 0.225,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0322 21.1098C31.4219 21.2987 31.0111 21.3046 30.8987 21.1191L31.371 21.8972C31.482 22.0802 31.8822 22.0779 32.4777 21.8965L32.0328 21.1096L32.0322 21.1098Z",
    fill: "#1E1D1D"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2134 15.6573C35.2582 16.512 34.153 18.122 32.7456 19.2542C31.3368 20.3868 30.1592 20.6119 30.1144 19.7572C30.0698 18.9031 31.1748 17.2925 32.5835 16.1599C33.9911 15.0283 35.1695 14.803 35.2141 15.6571L35.2134 15.6573Z",
    fill: "#1E1D1D",
    stroke: "#1E1D1D",
    strokeWidth: 0.225,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4451 14.6628L35.0691 15.2809C34.7071 14.9226 33.7209 15.245 32.5851 16.1589C31.1763 17.2915 30.0713 18.9021 30.1159 19.7562C30.1245 19.9214 30.1754 20.0461 30.2617 20.1315L29.6377 19.5135C29.5513 19.4274 29.5003 19.3027 29.4919 19.1381C29.4473 18.2841 30.5523 16.6734 31.9611 15.5408C33.0971 14.6277 34.0838 14.3044 34.4451 14.6628Z",
    fill: "#9583FF",
    stroke: "#1E1D1D",
    strokeWidth: 0.225,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3859 18.7702L29.7354 18.2081C29.5675 18.5633 29.4782 18.8852 29.4917 19.1394C29.5003 19.3046 29.5512 19.4293 29.6375 19.5148L30.2615 20.1328C30.175 20.0467 30.1241 19.9219 30.1157 19.7574C30.1016 19.4902 30.2002 19.1484 30.3859 18.7702Z",
    fill: "#1E1D1D"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3583 12.0305C32.4437 12.2786 31.4878 13.6082 30.2231 15.0008C28.9589 16.3926 27.8639 17.3203 27.7786 17.0729C27.6932 16.8249 28.6491 15.4953 29.914 14.1033C31.1787 12.7106 32.2737 11.7829 32.3591 12.031L32.3584 12.0312L32.3583 12.0305Z",
    fill: "#1E1D1D",
    stroke: "#1E1D1D",
    strokeWidth: 0.225,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6476 11.385L32.3429 12.005C32.1812 11.8612 31.1258 12.768 29.9139 14.1021C28.6496 15.4939 27.6931 16.8237 27.7785 17.0718C27.7821 17.0825 27.7872 17.0906 27.7946 17.0966L27.0994 16.4765C27.0926 16.4703 27.0867 16.4617 27.0833 16.4517C26.9978 16.2036 27.9537 14.874 29.2186 13.482C30.4306 12.148 31.4858 11.2404 31.6476 11.385Z",
    fill: "#9583FF",
    stroke: "#1E1D1D",
    strokeWidth: 0.225,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M28.185 16.2428L27.4807 15.6353C27.1999 16.05 27.049 16.3489 27.0851 16.4536C27.0887 16.4643 27.0938 16.4724 27.1012 16.4784L27.7964 17.0985C27.7897 17.0923 27.7837 17.0837 27.7803 17.0737C27.7439 16.9677 27.8977 16.6635 28.1848 16.2421L28.185 16.2428Z",
    fill: "#1E1D1D"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9535 13.8995C23.7786 13.2471 24.7495 11.7045 26.1208 10.4537C27.4934 9.20259 28.7471 8.71749 28.9219 9.36987C29.0968 10.0222 28.1259 11.5649 26.754 12.8159C25.3819 14.0661 24.1282 14.5512 23.9533 13.8988L23.9535 13.8995Z",
    fill: "white",
    stroke: "#1E1D1D",
    strokeWidth: 0.225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8203 9.19001L29.4585 9.81224C29.5049 9.85737 29.5392 9.91737 29.559 9.99144C29.7339 10.6438 28.763 12.1865 27.391 13.4374C26.1753 14.5453 25.0521 15.0523 24.6902 14.6998L24.0519 14.0776C24.4138 14.43 25.5371 13.9231 26.7528 12.8152C28.1254 11.5641 29.0956 10.0216 28.9208 9.36921C28.9009 9.29514 28.8668 9.23581 28.8203 9.19001Z",
    fill: "#9583FF",
    stroke: "#1E1D1D",
    strokeWidth: 0.225,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M25.467 13.7914C24.8067 14.1824 24.2799 14.2994 24.0537 14.0781L24.692 14.7004C24.907 14.9101 25.3912 14.8161 26.0036 14.4721L25.4675 13.7905L25.467 13.7914Z",
    fill: "#1E1D1D"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04485 17.7675L8.7693 18.5391C8.6294 18.9305 8.19083 19.2162 7.48107 19.3058C6.02648 19.49 3.98393 18.7829 2.91939 17.7256C2.37437 17.1848 2.19116 16.6563 2.33824 16.2454L2.61379 15.4738C2.4667 15.8847 2.64991 16.4132 3.19494 16.9541C4.25947 18.0113 6.30203 18.7184 7.75662 18.5343C8.46637 18.4447 8.90495 18.159 9.04485 17.7675Z",
    fill: "#9583FF",
    stroke: "#1E1D1D",
    strokeWidth: 0.225,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75732 18.5351C6.90105 18.6435 5.84085 18.4424 4.89598 18.0436L4.60324 18.8081C5.55161 19.2118 6.61988 19.4159 7.48109 19.3068C8.19084 19.2173 8.62942 18.9315 8.76932 18.5401L9.04486 17.7685C8.90496 18.16 8.46639 18.4457 7.75664 18.5353L7.75732 18.5351Z",
    fill: "#1E1D1D"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M3.90003 14.707C5.3553 14.5226 7.39718 15.23 8.46153 16.2865C9.52607 17.3438 9.21058 18.3496 7.75531 18.534C6.30072 18.7182 4.25817 18.011 3.19363 16.9538C2.12927 15.8972 2.44612 14.891 3.90071 14.7068L3.90003 14.707Z",
    fill: "white",
    stroke: "#1E1D1D",
    strokeWidth: 0.225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59646 16.4975L9.26884 17.2487C9.10281 17.6297 8.64579 17.8847 7.93181 17.9258C6.46736 18.0107 4.47813 17.1655 3.48805 16.038C2.98134 15.4607 2.83465 14.9217 3.00941 14.5216L3.33703 13.7703C3.16228 14.1704 3.30896 14.7094 3.81567 15.2868C4.80575 16.4142 6.79566 17.2593 8.25943 17.1746C8.97341 17.1334 9.43043 16.8784 9.59646 16.4975Z",
    fill: "#9583FF",
    stroke: "#1E1D1D",
    strokeWidth: 0.225,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M4.67418 13.0917C6.13796 13.007 8.12718 13.8523 9.11709 14.979C10.1072 16.1065 9.72266 17.0886 8.25888 17.1732C6.79442 17.2581 4.8052 16.4129 3.81511 15.2854C2.82521 14.1587 3.20973 13.1766 4.67418 13.0917Z",
    fill: "white",
    stroke: "#1E1D1D",
    strokeWidth: 0.225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M4.67418 13.0917C6.13796 13.007 8.12719 13.8523 9.11709 14.979C10.1072 16.1065 9.72266 17.0886 8.25888 17.1732C6.79442 17.2581 4.8052 16.4129 3.81511 15.2854C2.82521 14.1587 3.20973 13.1766 4.67418 13.0917Z",
    stroke: "#1E1D1D",
    strokeWidth: 0.225,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25981 17.1731C7.44759 17.2202 6.47399 16.9806 5.59919 16.5659L5.29307 17.3267C6.16265 17.7355 7.12695 17.9703 7.93269 17.9235C8.64667 17.8823 9.10369 17.6273 9.26972 17.2464L9.59734 16.4951C9.43131 16.8761 8.97429 17.131 8.26031 17.1722L8.25981 17.1731Z",
    fill: "#1E1D1D"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M4.84578 11.3667L5.39238 10.8452C4.83889 11.3736 4.8157 12.4097 5.42881 13.5471L4.8822 14.0686C4.26891 12.9305 4.2921 11.8944 4.84578 11.3667Z",
    fill: "#9583FF",
    stroke: "#1E1D1D",
    strokeWidth: 0.225,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42893 13.5462C4.58758 11.9842 4.94457 10.614 6.22698 10.4861C7.50872 10.3584 9.22943 11.5203 10.071 13.083C10.9121 14.6444 10.5551 16.0146 9.27341 16.1423C7.99099 16.2702 6.27029 15.1083 5.42893 13.5462Z",
    fill: "white",
    stroke: "#1E1D1D",
    strokeWidth: 0.225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42893 13.5462C4.58758 11.9842 4.94457 10.614 6.22698 10.4861C7.50872 10.3584 9.22943 11.5203 10.071 13.083C10.9121 14.6444 10.5551 16.0146 9.27341 16.1423C7.99099 16.2702 6.27029 15.1083 5.42893 13.5462Z",
    stroke: "#1E1D1D",
    strokeWidth: 0.225,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1075 15.7852L9.5609 16.3067C9.35489 16.5032 9.07481 16.6299 8.72711 16.6648C7.44469 16.7927 5.72399 15.6308 4.88263 14.0687L5.42924 13.5472C6.27041 15.1086 7.9913 16.2712 9.27371 16.1433C9.62142 16.1084 9.901 15.9825 10.1075 15.7852Z",
    fill: "#9583FF",
    stroke: "#1E1D1D",
    strokeWidth: 0.225,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2725 16.1429C8.47551 16.2223 7.50998 15.8036 6.69042 15.1003L6.09444 15.5789C6.92382 16.308 7.9134 16.7458 8.72589 16.6644C9.0736 16.6295 9.35318 16.5037 9.55969 16.3063L10.1063 15.7848C9.90029 15.9813 9.6202 16.108 9.2725 16.1429Z",
    fill: "#1E1D1D"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23267 9.24089L7.57973 8.60096C7.40878 8.91695 7.36038 9.30428 7.46387 9.74196L7.11681 10.3819C7.01264 9.94439 7.06086 9.55639 7.23267 9.24089Z",
    fill: "#9583FF",
    stroke: "#1E1D1D",
    strokeWidth: 0.225,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5842 11.8523L13.2369 12.4923C12.8786 13.1534 11.9814 13.4979 10.815 13.3165C9.09297 13.0493 7.43578 11.7357 7.11476 10.3832L7.46201 9.74316C7.78303 11.0957 9.44022 12.4093 11.1623 12.6765C12.3285 12.8572 13.2257 12.5128 13.5842 11.8523Z",
    fill: "#9583FF",
    stroke: "#1E1D1D",
    strokeWidth: 0.225,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1636 12.6763C10.6383 12.5948 10.1195 12.4155 9.64203 12.1675L9.28721 12.8037C9.76655 13.0534 10.2879 13.2342 10.8163 13.3163C11.9826 13.497 12.8798 13.1526 13.2383 12.4921L13.5855 11.8521C13.2272 12.5132 12.33 12.8577 11.1636 12.6763Z",
    fill: "#1E1D1D"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46499 9.74229C7.14379 8.3891 8.27936 7.50955 10.0014 7.77669C11.7243 8.04432 13.3815 9.35798 13.7027 10.7112C14.0237 12.0637 12.8883 12.9439 11.1654 12.6763C9.44339 12.4091 7.7862 11.0955 7.46518 9.74297L7.46499 9.74229Z",
    fill: "white",
    stroke: "#1E1D1D",
    strokeWidth: 0.225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46499 9.74229C7.14379 8.3891 8.27936 7.50955 10.0014 7.77669C11.7243 8.04432 13.3815 9.35798 13.7027 10.7112C14.0237 12.0637 12.8883 12.9439 11.1654 12.6763C9.44339 12.4091 7.7862 11.0955 7.46518 9.74297L7.46499 9.74229Z",
    stroke: "#1E1D1D",
    strokeWidth: 0.225,
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9978 5.99814L12.7093 5.73327C11.7711 6.08216 11.4015 7.57377 11.8884 9.23801L11.1768 9.50289C10.6897 7.83797 11.0595 6.34704 11.9978 5.99814Z",
    fill: "#9583FF",
    stroke: "#1E1D1D",
    strokeWidth: 0.225,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8876 9.23959C11.3614 7.43948 11.8361 5.84252 12.9484 5.67279C14.0608 5.50305 15.3893 6.82463 15.9155 8.62473C16.442 10.4255 15.9673 12.0225 14.8551 12.1929C13.7427 12.3626 12.4141 11.0404 11.8869 9.23977L11.8876 9.23959Z",
    fill: "white",
    stroke: "#1E1D1D",
    strokeWidth: 0.225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8876 9.23959C11.3614 7.43948 11.8361 5.84252 12.9484 5.67279C14.0608 5.50305 15.3893 6.82463 15.9155 8.62473C16.442 10.4255 15.9673 12.0225 14.8551 12.1929C13.7427 12.3626 12.4141 11.0404 11.8869 9.23977L11.8876 9.23959Z",
    stroke: "#1E1D1D",
    strokeWidth: 0.225,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0937 12.1311L14.3821 12.3959C14.3059 12.4243 14.2262 12.445 14.1423 12.458C13.0299 12.6277 11.7012 11.3055 11.1741 9.50486L11.8857 9.23998C12.4121 11.0408 13.7408 12.363 14.8538 12.1931C14.9371 12.1803 15.0175 12.1595 15.0937 12.1311Z",
    fill: "#9583FF",
    stroke: "#1E1D1D",
    strokeWidth: 0.225,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0205 11.2307C12.6409 12.0689 13.4356 12.5655 14.1434 12.4575C14.2266 12.4446 14.3071 12.4238 14.3832 12.3954L15.0948 12.1305C15.0186 12.159 14.9389 12.1796 14.855 12.1926C14.1479 12.3004 13.3535 11.8052 12.7335 10.9683L12.0205 11.2307Z",
    fill: "#1E1D1D"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5317 5.32829L18.3252 5.6868C18.1876 5.62461 18.0177 5.62712 17.8191 5.70436C16.942 6.04489 15.8293 7.70565 15.3327 9.41408C14.9488 10.7354 15.0457 11.6978 15.5149 11.9094L14.7214 11.5509C14.2523 11.3393 14.156 10.3767 14.5393 9.05556C15.0359 7.34713 16.1485 5.68637 17.0257 5.34584C17.2243 5.26861 17.3941 5.26609 17.5317 5.32829Z",
    fill: "#9583FF",
    stroke: "#1E1D1D",
    strokeWidth: 0.225,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0193 11.8926C15.1422 12.2332 14.8346 11.1239 15.331 9.41484C15.8276 7.70642 16.9403 6.04566 17.8174 5.70513C18.6945 5.3646 19.0021 6.47381 18.5062 8.18205C18.0098 9.89116 16.8964 11.5521 16.02 11.8924L16.0193 11.8926Z",
    fill: "#1E1D1D",
    stroke: "#1E1D1D",
    strokeWidth: 0.225,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5139 11.9091C15.2471 11.789 15.1014 11.4245 15.0957 10.89L14.3045 10.6066C14.3231 11.0998 14.4665 11.4365 14.7209 11.5512L15.5141 11.9098L15.5139 11.9091Z",
    fill: "#1E1D1D"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2862 13.0969C22.4742 13.7674 22.314 13.0936 22.9277 11.5935C23.5418 10.0925 24.6979 8.33268 25.51 7.66285C26.3215 6.99321 26.4822 7.66613 25.8674 9.16732C25.2538 10.6675 24.0977 12.4273 23.2862 13.0969Z",
    fill: "#1E1D1D",
    stroke: "#1E1D1D",
    strokeWidth: 0.225,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3234 6.96863L26.1141 7.42839C25.9943 7.35924 25.7916 7.42955 25.5092 7.66178C24.6972 8.33229 23.5416 10.0912 22.9268 11.5924C22.5262 12.5715 22.4553 13.1987 22.6805 13.3292L21.8898 12.8695C21.6646 12.7389 21.7355 12.1118 22.1361 11.1326C22.7502 9.63164 23.9063 7.87185 24.7185 7.20202C25 6.96929 25.2034 6.8988 25.3234 6.96863Z",
    fill: "#9583FF",
    stroke: "#1E1D1D",
    strokeWidth: 0.225,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8545 11.951C21.7204 12.4589 21.7361 12.781 21.8896 12.8702L22.6801 13.33C22.5246 13.2391 22.5109 12.9107 22.65 12.392L21.8551 11.9508L21.8545 11.951Z",
    fill: "#1E1D1D"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6893 12.4637L18.9427 12.2689C18.8244 12.2379 18.7095 12.1871 18.5999 12.1152L19.3465 12.31C19.4561 12.3819 19.571 12.4327 19.6893 12.4637Z",
    fill: "white",
    stroke: "#1E1D1D",
    strokeWidth: 0.225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6608 5.66148L21.4075 5.85627C20.5229 5.62557 19.447 6.51827 18.8609 8.05328C18.1966 9.79354 18.4137 11.699 19.3447 12.3098L18.5981 12.115C17.6671 11.5042 17.4497 9.59806 18.1143 7.85849C18.6997 6.32366 19.7756 5.43096 20.6608 5.66148Z",
    fill: "#9583FF",
    stroke: "#1E1D1D",
    strokeWidth: 0.225,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3453 12.31C18.4143 11.6992 18.197 9.79305 18.8615 8.05347C19.5254 6.31407 20.8192 5.39945 21.7502 6.01027C22.6821 6.62159 22.8992 8.52706 22.2354 10.2665C21.571 12.0067 20.2779 12.9212 19.3462 12.3105L19.3455 12.3107L19.3453 12.31Z",
    fill: "white",
    stroke: "#1E1D1D",
    strokeWidth: 0.225,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultitap);
export default __webpack_public_path__ + "static/media/Multitap.fdad1d2710cbdc2d8c19346fa12cbb4c.svg";
export { ForwardRef as ReactComponent };